import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "rm-cookie-consent-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const persist = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, date: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed left-4 right-4 z-[60] bottom-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md"
      role="dialog"
      aria-live="polite"
      aria-label="Bandeau de consentement aux cookies"
    >
      <div className="bg-[#001B35] text-white rounded-2xl shadow-2xl border border-white/10 overflow-hidden">
        <div className="p-5 sm:p-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#005BBB]/20 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 text-[#5dade2]" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-display font-bold uppercase tracking-wider text-sm">
                Cookies & vie privée
              </p>
              <p className="mt-2 text-sm text-[#cfdbe8] leading-relaxed">
                Ce site utilise des cookies pour améliorer votre expérience et
                analyser le trafic. Aucune donnée personnelle n'est partagée à
                des fins commerciales.{" "}
                <Link
                  to="/confidentialite"
                  className="text-[#5dade2] underline hover:text-white"
                >
                  En savoir plus
                </Link>
                .
              </p>
            </div>
            <button
              type="button"
              onClick={() => persist("dismissed")}
              data-testid="cookie-close"
              aria-label="Fermer le bandeau"
              className="p-1 text-[#9bb6d6] hover:text-white"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          <div className="mt-5 flex flex-col sm:flex-row gap-2.5">
            <button
              type="button"
              onClick={() => persist("rejected")}
              data-testid="cookie-reject"
              className="flex-1 px-4 py-2.5 rounded-full text-sm font-semibold border border-white/20 hover:bg-white/10 transition"
            >
              Refuser
            </button>
            <button
              type="button"
              onClick={() => persist("accepted")}
              data-testid="cookie-accept"
              className="flex-1 px-4 py-2.5 rounded-full text-sm font-semibold bg-[#005BBB] hover:bg-[#0072e8] text-white transition btn-shine"
            >
              Tout accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
